import { toast } from 'react-toastify'

import { orders } from '../api/services/orders'
import { DateString } from '../api/services/orders/types.ts'

export const realizeOrder = async (
  orderID: number | undefined,
  dietBaseFolderId: number | null,
  selectedDietID: number | null,
  scheduledDate: DateString,
  loadingToastText: string,
  successToastText: string,
) => {
  const response = { message: 'fail'}

  if (orderID && (dietBaseFolderId || selectedDietID)) {
    const toastId = toast.loading(loadingToastText)
    try {
      const postResponse = await orders.postRealizeOrder(
        orderID,
        dietBaseFolderId,
        selectedDietID,
        scheduledDate
      )
      if (postResponse.message === 'success') {
        response.message = 'success'
        toast.update(toastId, {
          render: successToastText,
          type: 'success',
          delay: 1000,
          isLoading: false,
          autoClose: 3000
        })
      }
    } catch {
      toast.dismiss(toastId)
    }
    return response
  }
}